<template>
    <div ref="a4" class="blank-page">
        <template v-if="selected_signs.length == 0" >
            <div v-for="index in pages" :key="index" class="wrapper" :class="{break:index > 0}">
                <div v-for="cell in 4" :key="cell" class="sign">
                    <SingleSaleCatalogy />
                </div>
            </div>
        </template>
        <template v-else>
            <div v-for="(page,index) in pagination.pages" :key="page" class="wrapper" :class="{break:index > 0}">
                <template v-for="sign in pagination.signs[index]" :key="sign.barcode">
                    <div class="sign">
                        <SignSaleForFour :sign="sign"/>
                    </div>
                </template>
            </div>
        </template>
    </div>

</template>

<script>
import { ref } from '@vue/reactivity'
import SignSaleForFour from './components/SignSaleForFour.vue'
import {is_sales_print,pagination_signs} from '../Scripts/scripts'
import {is_deleted, printer_amount,selected_deals} from '../components/Deals/Scripts/store'
import { watch } from '@vue/runtime-core'
import SingleSaleCatalogy from '../components/ShilutCatalogy/SingleSaleCatalogy.vue'

export default {
    props:['pages','selected_signs'],
    components:{SignSaleForFour,SingleSaleCatalogy},
    setup(props){

        const {organise_signs,pagination} = pagination_signs()

        const a4 = ref()

        /*
            רביעיית שלטים מבצע חם:
            עיצוב כל שלט זהה לרביעיית שלטי יום הולדת, מוקטן פרופורציונלית (~0.66)
            כדי להיכנס לחלל התוכן שנותר אחרי השוליים השמורים בכל שלט:
            2 ס"מ מלמעלה ו-1.5 ס"מ מלמטה.
            השוליים הם padding בתוך כל שלט (לא תלויים בהגדרות דיאלוג ההדפסה)
            ו-overflow:hidden מבטיח שהתוכן לא יחרוג אל הנייר הממותג.
            הערה: h1 נשאר ב-2em כברירת מחדל (כמו ביום הולדת) כדי שהמחיר יודפס גדול ובולט.
        */
        const handle_print = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css' ;
            var css = `
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');

* {
  direction: rtl;
  font-family: 'Rubik', sans-serif;
  font-weight: normal;
  box-sizing: border-box;
}

/* zero only the page container's margins (the print window's body defaults to 8px);
   element margins are left intact so the layout stays identical to Birthday */
html, body {
  margin: 0;
  padding: 0;
}

@page {
  size: A4;
  margin: 0;
}

@media print {
  .no-see-in-print,
  .float-icon,
  .add-icon,
  .clean-icon {
    display: none;
  }

  .break {
    page-break-before: always;
  }
}

.blank-page {
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
}

.wrapper {
  width: 100%;
  height: 29.6cm;
  margin: 0 auto;
}

.sign-sale-header > h2 {
  font-weight: bold !important;
}

/* כל שלט: תא של 7.4 ס"מ עם אזור שמור 2 ס"מ מלמעלה ו-0.5 ס"מ מלמטה (padding).
   overflow:hidden חותך כל תוכן חורג כך שלא יזלוג אל הנייר הממותג. */
.wrapper .sign {
  width: 100%;
  height: 7.4cm;
  padding: 2cm 0.5cm 0.5cm 0.5cm;
  overflow: hidden;
}

.sign-sale {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* keep each section at its % height; the big 2em price overflows visually
   (centered, like Birthday) instead of pushing the footer past the bottom margin */
.sign-sale > * {
  min-height: 0;
}

.sign-sale-header {
  position: relative;
  width: 100%;
  height: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

/* המגבלות בתחתית השלט: מודגשות ובגופן גדול ב-1px כדי שיבלטו בהדפסה */
.prormo-limit {
  height: 13%;
  width: 100%;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  order: 3;
  overflow: hidden;
  padding: 0 4px;
}

.prormo-limit p {
  margin: 0;
  white-space: nowrap;
  font-size: 14px;
  font-weight: bold !important;
  color: #000;
}

.logo {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 100px;
  height: 100%;
}

.logo img {
  width: 100px;
  height: 20px;
}

.sign-sale-input-texts {
  width: 100%;
  height: 27%;
}

.sign-sale-input-texts :is(.he, .ru) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.sign-sale-input-texts .he {
  font-size: 30px;
}

.sign-sale-input-texts .ru {
  font-size: 18px;
}

.sign-sale-contents {
  width: 100%;
  height: 35%;
  display: flex;
  font-size: 44px;
}

.sign-sale-contents.catalog {
  justify-content: center;
  align-items: center;
}

.col {
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-1 {
  width: 10%;
  height: 100%;
}

.col-2 {
  width: 45%;
  height: 100%;
}

/* barcode label + numbers as one centered line so they never collide or clip
   off the right edge (the old RTL flex row overlapped the two pieces) */
.col.barcodes {
  width: 100%;
  font-size: 13px;
  display: block;
  text-align: right;
  white-space: nowrap;
  order: 2;
  padding: 2px 4px 1px 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}

.col.barcodes h1 {
  display: inline;
}

.col.small {
  width: 30%;
  font-size: 21px;
}

.col.price {
  width: 100%;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  order: 1;
  padding: 1px 0;
}

.col.price > small {
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}

[data-slice] {
  white-space: nowrap;
  font-size: 13px;
}

[data-fixed] {
  display: flex;
  align-items: center;
  font-size: 13px;
}

.sign-sale-footer {
  width: 100%;
  height: 23%;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  justify-content: space-between;
  padding: 1px 4px;
  overflow: hidden;
}

.sign-sale-footer.item-error {
  justify-content: center;
  align-items: center;
  color: red;
}

.choos-item {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--main);
  z-index: 1000;
}

/* Animation */
.slide-in-top {
  -webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
`;

            if(styleElem.styleSheet){
                styleElem.styleSheet.cssText = css;
            }
            else{
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin= window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }
        const handle_print_catalogy = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css' ;
            var css = `
                @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                *{
                    direction:rtl;
                    font-family: 'Rubik', sans-serif;
                    font-weight:normal;
                    padding: 0;
                    margin: 0;
                    box-sizing: border-box;
                }
                h1{
                    font-size: inherit;
                }
                @media print {
                    .no-see-in-print{
                        display:none
                    }
                    .float-icon{
                        display:none;
                    }
                    .add-icon,.clean-icon{
                        display:none;
                    }
                    .break{
                        page-break-before: always;
                    }
                }
                @page {
                    size: A4;
                    margin: 0;
                }
                .blank-page{
                    width:100%;
                }
                .wrapper{
                    width:100%;
                    height: 29.6cm;
                }
                .wrapper .sign{
                    width: 100%;
                    height: 7.4cm;
                    padding: 2cm 0.5cm 0.5cm 0.5cm;
                    overflow: hidden;
                }
                .sign-sale{
                    width: 100%;
                    height: 100%;
                }
                .sign-sale-header{
                    position: relative;
                    width: 100%;
                    height: 15%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 15px;
                    border-bottom: 1px solid black;
                }
                .prormo-limit{
                    height: 8%;
                    width: 100%;
                    font-size: 11px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .sign-sale-input-texts{
                    position: relative;
                    width: 100%;
                    height: 30%;
                }
                .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    text-align: center;
                }
                .sign-sale-input-texts .ru{
                    font-size:14px;
                }
                .sign-sale-contents{
                    width: 100%;
                    height: 35%;
                    display: flex;
                    font-size: 28px;
                }
                .sign-sale-contents.catalog{
                    justify-content: center;
                    align-items: center;
                }
                .col{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .col-1{
                    width: 10%;
                    height: 100%;
                }
                .col-2{
                    width: 45%;
                    height: 100%;
                }
                .col.barcodes{
                    width: 100%;
                    font-size: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    order: 2;
                    padding: 1px 0;
                    gap: 4px;
                }
                .col.small{
                    font-size: unset;
                    text-align: center;
                    width: 30%;
                    font-size: 18px;
                }
                .col.price{
                    width: 100%;
                    font-size: 13px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    order: 1;
                    padding: 1px 0;
                }
                .col.price > small{
                    font-weight: 500;
                    font-size: 14px;
                    white-space: nowrap;
                }

                [data-slice]{
                    white-space: nowrap;
                    font-size: 11px;
                }
                [data-fixed]{
                    display: flex;
                    align-items: center;
                    font-size: 11px;
                }
                .sign-sale-footer{
                    width: 100%;
                    height: 20%;
                    display: flex;
                    flex-direction: column;
                    font-size: 11px;
                    justify-content: space-between;
                    padding: 1px 5px;
                    overflow: hidden;
                }
            `
            if(styleElem.styleSheet){
                styleElem.styleSheet.cssText = css;
            }
            else{
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin= window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }

        if(props.selected_signs && props.selected_signs.length > 0){
            organise_signs(4,props.selected_signs)
        }

        printer_amount.value = []
        is_deleted.value = false
        watch(is_sales_print,()=>{
            if(is_sales_print.value && props.selected_signs.length > 0){
                setTimeout(() => {
                    handle_print()
                }, 500);
            }
            else if(is_sales_print.value && props.selected_signs.length == 0){
                 setTimeout(() => {
                    handle_print_catalogy()
                }, 500);
            }
        })

        watch(selected_deals.value,()=>{
            organise_signs(4,selected_deals.value)
        })

        return{
            handle_print,
            pagination,
            a4,
        }
    }
}
</script>

<style scoped>
    .blank-page{
        width: 100%;
        min-height: 100%;
        background: #fff;
        padding: 5px;
    }
    .wrapper{
        width: 100%;
        height: 297mm;
    }
    /* תצוגה מקדימה התואמת להדפסה: 2 ס"מ שמורים למעלה ו-0.5 ס"מ למטה בכל שלט */
    .wrapper .sign{
        position: relative;
        width: 100%;
        height: calc(100% / 4);
        border: 1px solid black;
        padding: 20mm 5mm 5mm 5mm;
    }
    .wrapper .sign::before{
        content: 'אזור שמור - 2 ס"מ (לא מודפס)';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 20mm;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b5b5b5;
        font-size: 12px;
        border-bottom: 1px dashed #ff6347;
        pointer-events: none;
    }
    .wrapper .sign::after{
        content: 'אזור שמור - 0.5 ס"מ (לא מודפס)';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5mm;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b5b5b5;
        font-size: 12px;
        border-top: 1px dashed #ff6347;
        pointer-events: none;
    }
</style>
